import React from 'react';

import DisplayTitleBar from 'components/Meteorology/Fields/DisplayTitleBar';
import ImageDownloadButton from 'components/Meteorology/Fields/ImageDownloadButton';

import './index.scss';

export default function TitleBar({
  showDownload,
  showInstructions,
  onDownloadClick,
  downloadDisabled,
}: {
  showDownload: boolean,
  showInstructions: boolean,
  onDownloadClick: () => void,
  downloadDisabled: boolean,
}) {
  return (
    <DisplayTitleBar tab="numericForecast">
      {showDownload && (
        <div className={`numeric-forecast-download ${showInstructions ? 'show-instruction' : ''}`}>
          <ImageDownloadButton onClick={onDownloadClick} disabled={downloadDisabled} />
          {showInstructions && (
            <div className="instruction-number">
              4
            </div>
          )}
        </div>
      )}
    </DisplayTitleBar>
  );
}
